import { render, staticRenderFns } from "./InvoicesRecord.vue?vue&type=template&id=a31c7790&scoped=true"
import script from "./InvoicesRecord.vue?vue&type=script&lang=js"
export * from "./InvoicesRecord.vue?vue&type=script&lang=js"
import style0 from "./InvoicesRecord.vue?vue&type=style&index=0&id=a31c7790&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a31c7790",
  null
  
)

export default component.exports